module.exports = __webpack_public_path__ + "static/img/laboratory5.06ddfa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory5.jpg
// module id = XQwf
// module chunks = 1